import { useMutation, useQueryClient } from 'react-query';

import { applicantDetailsRoute } from '@features/applicant';
import {
  employerApplicationsKey,
  updateApplicationNotesRoute,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type UseUpdateApplicationRatingProps = {
  searchValue: string;
};

export const useUpdateApplicationRating = ({
  searchValue,
}: UseUpdateApplicationRatingProps) => {
  const client = useQueryClient();
  const { mutate: updateApplicationRating } = useMutation({
    mutationFn: (variables: { rating: number; application_id: number }) =>
      axiosInstance
        .post(updateApplicationNotesRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status === 200) {
        client.invalidateQueries(employerApplicationsKey);
        client.invalidateQueries(searchValue);
      }
    },
  });
  return { updateApplicationRating };
};
